import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Package } from "lucide-react";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/orders").then(({data}) => setOrders(data)).finally(() => setLoading(false)); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow mb-2">Orders</div>
        <h1 className="page-title">Order workflow</h1>
        <p className="text-sm text-slate-500 mt-1 max-w-2xl">Payments and shipping integrations are coming soon. No autonomous purchasing — every financial step requires human approval.</p>
      </div>
      <div className="surface">
        {loading ? (
          <div className="p-5 space-y-3">{[...Array(3)].map((_,i)=>(<div key={i} className="skeleton h-16"/>))}</div>
        ) : orders.length === 0 ? (
          <div className="p-10 text-center text-slate-500">
            <Package className="mx-auto text-slate-300 mb-3" size={32}/>
            <div>No orders yet.</div>
          </div>
        ) : (
          <ul className="divide-y divide-slate-100">
            {orders.map((o) => (
              <li key={o.id} className="px-5 py-4" data-testid={`order-${o.id}`}>
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="font-semibold tracking-tight">{o.supplier_name}</div>
                    <div className="text-xs text-slate-500 mt-1">
                      Status: <span className="pill bg-slate-100 text-slate-600 border-slate-200">{o.status.replace(/_/g,' ')}</span>
                      <span className="mx-2">·</span>
                      Payment: {o.payment_status.replace(/_/g,' ')}
                      <span className="mx-2">·</span>
                      Shipping: {o.shipping_status.replace(/_/g,' ')}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-mono text-lg tabular-nums">{o.currency} {o.total_amount?.toLocaleString()}</div>
                    <div className="text-[11px] text-slate-400 font-mono mt-0.5">{o.id.slice(0,8)}</div>
                  </div>
                </div>
                <div className="mt-3 pill bg-amber-50 text-amber-800 border-amber-200">Payment integration — Coming soon</div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
